import { render, staticRenderFns } from "./Slider.vue?vue&type=template&id=ff7b91dc&scoped=true&"
import script from "./Slider.vue?vue&type=script&lang=ts&"
export * from "./Slider.vue?vue&type=script&lang=ts&"
import style0 from "./Slider.vue?vue&type=style&index=0&id=ff7b91dc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff7b91dc",
  null
  
)

export default component.exports